import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useBoxCatalogViewStore } from 'ecommerce/stores/boxCatalogView.store';
import dayjs from 'dayjs';

const useBoxCatalogView = () => {
  const boxCatalogViewStore = useBoxCatalogViewStore();

  const {
    getTimeRange,
    getFilters,
    getPageConfig,
    getSelectedSchedule,
    getLoading,
    getIsModalReservationOpen,
    getCatalogCodeComponent,
    getCatalogModalComponent,
    flags,
    allTimeRanges,
    getOtherActivities,
  } = storeToRefs(boxCatalogViewStore);

  /*Query*/
  const onPaginatedBoxes = async box_slug => {
    await boxCatalogViewStore.getPaginatedBoxActivities(box_slug);
  };

  /*Date fields*/
  const onSetTimeSlot = timeSlotId => {
    boxCatalogViewStore.onSetTimeSlot(timeSlotId);
  };

  const onSetDate = selectedDate => {
    boxCatalogViewStore.onSetDate(selectedDate);
  };

  /**
   * @return getTimeRange.date formatted to YYYY-MM-DD
   */
  const getFormattedDate = computed(() => {
    return dayjs(getTimeRange.value.date).format('YYYY-MM-DD');
  });
  const onSetSchedule = schedule => {
    boxCatalogViewStore.onSetSchedule(schedule);
  };
  /*Filters fields*/

  const onSetProvince = provinceID => {
    boxCatalogViewStore.onSetProvince(provinceID);
  };

  const onSetOrderBy = orderBy => {
    boxCatalogViewStore.onSetOrderBy(orderBy);
  };

  const onSetSearchTerm = searchTerm => {
    boxCatalogViewStore.onSetSearchTerm(searchTerm);
  };

  const onSetPage = pageNumber => {
    boxCatalogViewStore.onSetPage(pageNumber);
  };

  const onSetPerPage = productsQuantity => {
    boxCatalogViewStore.onSetPerPage(productsQuantity);
  };

  const onToggleModalReservation = () => {
    boxCatalogViewStore.onToggleModalReservation();
  };

  const onActivityBySlug = async slug => {
    await boxCatalogViewStore.onActivityBySlug(slug);
  };

  const onCreateReservation = async status => {
    boxCatalogViewStore.onCreateReservation(status);
  };

  const resetPageConfig = () => {
    boxCatalogViewStore.resetPageConfig();
  };

  const generateTitleDate = () => {
    boxCatalogViewStore.generateTitleDate();
  };

  const cleanAvailability = () => {
    boxCatalogViewStore.cleanAvailability();
  };

  const setATT = (isATT = false) => {
    boxCatalogViewStore.setATT(isATT)
  }

  return {
    onPaginatedBoxes,
    onSetTimeSlot,
    onSetDate,
    onSetSchedule,
    onSetProvince,
    onSetOrderBy,
    onSetSearchTerm,
    onSetPage,
    onSetPerPage,
    onToggleModalReservation,
    onActivityBySlug,
    onCreateReservation,
    resetPageConfig,
    generateTitleDate,
    cleanAvailability,
    setATT,
    flags,
    allTimeRanges,
    getFlags: computed(() => flags.value),
    getOtherActivities,
    getFormattedDate,
    getTimeRange: computed(() => getTimeRange.value),
    getFilters: computed(() => getFilters.value),
    getPageConfig: computed(() => getPageConfig.value),
    getSelectedSchedule: computed(() => getSelectedSchedule.value),
    loading: computed(() => getLoading.value),
    getIsModalReservationOpen: computed({
      get: () => getIsModalReservationOpen.value,
      set: () => onToggleModalReservation(),
    }),
    getCatalogCodeComponent: computed(() => getCatalogCodeComponent.value),
    getCatalogModalComponent: computed(() => getCatalogModalComponent.value),
  };
};

export default useBoxCatalogView;
